import type { QueryKey, UseQueryOptions } from "@tanstack/react-query";
import type { ApiResponse } from "../Types";

export const DEFAULT_STALE_TIME = 30 * 1000;
export const LOOKUP_STALE_TIME = 10 * 60 * 1000;

export type ServiceQueryOptions<TData = any> = Omit<
  UseQueryOptions<TData | null, Error, TData | null, QueryKey>,
  "queryKey" | "queryFn"
>;

export const unwrapApiResponse = <TData>(
  res: ApiResponse<TData>,
): TData | ApiResponse<TData> | null => {
  if (!res?.success) {
    return null;
  }

  return res.data ?? res;
};
